
export default {
  name: 'Contacts',

  computed: {
    vars: function () {
      return this.$store.state.appState?.vars || {};
    },

    listContacts: function () {
      const vars = { ...this.vars };
      const list = [];

      // if (vars['Стационарный телефон']) {
      //   list.push({
      //     label: this.$phoneFormat(vars['Стационарный телефон']),
      //     link: `tel:${vars['Стационарный телефон']}`,
      //     icon: require('~/assets/img/svg/common/phone-white.svg'),
      //   });
      // }
      // if (vars['Мобильный телефон']) {
      //   list.push({
      //     label: this.$phoneFormat(vars['Мобильный телефон']),
      //     link: `tel:${vars['Мобильный телефон']}`,
      //     icon: require('~/assets/img/svg/common/mobile-white.svg'),
      //   });
      // }
      if (vars['Полный адрес']) {
        list.push({
          label: vars['Полный адрес'],
          icon: require('~/assets/img/svg/common/map-pin-white.svg'),
        });
      }
      if (vars['Адрес шиномонтажа']) {
        list.push({
          label: vars['Адрес шиномонтажа'],
          icon: require('~/assets/img/svg/common/map-pin-white.svg'),
        });
      }

      return list;
    },
    socials: function () {
      const config = this.$store.state?.appState?.config || {};
      const list = [];

      // if (config?.whatsapp) {
      //   list.push({
      //     image: require('~/assets/img/svg/socials/whatsapp.svg'),
      //     link: config?.whatsapp,
      //   });
      // }
      // if (config?.telegram) {
      //   list.push({
      //     image: require('~/assets/img/svg/socials/telegram.svg'),
      //     link: config?.telegram,
      //   });
      // }
      if (config?.vkontakte) {
        list.push({
          image: require('~/assets/img/svg/socials/vk.svg'),
          link: config?.vkontakte,
        });
      }

      return list;
    },

    contacts: function () {
      const vars = this.$store.state.appState?.vars || {};

      const list = [];
      if (vars['Интернет магазин (телефон)']) {
        list.push({
          text: 'Интернет магазин',
          phone: this.$phoneFormat(vars['Интернет магазин (телефон)']),
          link: `tel:${vars['Интернет магазин (телефон)']}`,
          whatsapp: `https://api.whatsapp.com/send?phone=${vars['Интернет магазин (WhatsApp)']}`,
          telegramm: vars['Интернет магазин (телеграм)'],
        });
      }
      if (vars['Шиномонтаж и услуги (телефон)']) {
        list.push({
          text: 'Шиномонтаж и услуги',
          phone: this.$phoneFormat(vars['Шиномонтаж и услуги (телефон)']),
          link: `tel:${vars['Шиномонтаж и услуги (телефон)']}`,
          whatsapp: `https://api.whatsapp.com/send?phone=${vars['Шиномонтаж и услуги (WhatsApp)']}`,
          telegramm: vars['Шиномонтаж и услуги (телеграм)'],
        });
      }

      return list;
    },
  },
};
